/** Local UI-only mock for Section 2. Never treated as real AI output in production. */
export const isAiUiMockEnabled = () =>
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_AI_MOCK !== 'false';

const asString = (value) => (typeof value === 'string' ? value : value == null ? '' : String(value));

const trim = (value) => asString(value).trim();

/** Always emit every Prospect DB field so create/update never drop keys. */
export const formToProspectPayload = (form = {}) => ({
  fullName: trim(form.fullName),
  company: trim(form.company),
  title: trim(form.title),
  linkedin: trim(form.linkedin),
  howDoYouKnowThisPerson: trim(form.howDoYouKnowThisPerson),
  whyClientRelevant: trim(form.whyClientRelevant),
  anythingElse: trim(form.anythingElse),
});

/** Include session communication fields for backend length validation (not persisted). */
export const formToHandleReplyPayload = (form = {}) => ({
  ...formToProspectPayload(form),
  latestProspectReply: asString(form.latestProspectReply),
  communicationHistory: asString(form.communicationHistory),
});

export const prospectToFormFields = (prospect = {}) => ({
  fullName: asString(prospect.fullName),
  company: asString(prospect.company),
  title: asString(prospect.title),
  linkedin: asString(prospect.linkedin),
  howDoYouKnowThisPerson: asString(prospect.howDoYouKnowThisPerson),
  whyClientRelevant: asString(prospect.whyClientRelevant),
  anythingElse: asString(prospect.anythingElse),
});

export const canSaveProspect = (form) =>
  Boolean(trim(form.fullName) && trim(form.company));

/** Handle a Reply Generate requires name, company, and the latest prospect reply. */
export const canGenerateHandleReply = (form) =>
  Boolean(trim(form.fullName) && trim(form.company) && trim(form.latestProspectReply));
